import { SafeImg } from './ScrollReveal';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0">
        <SafeImg
          src="https://readdy.ai/api/search-image?query=A%20warm%20artistic%20illustration%20of%20cozy%20manga%20reading%20atmosphere%20with%20soft%20ambient%20lighting%20featuring%20abstract%20ink%20wash%20brushstrokes%20in%20warm%20coral%20and%20cream%20tones%2C%20subtle%20paper%20texture%20background%2C%20gentle%20gradient%20from%20warm%20white%20to%20soft%20peach%2C%20delicate%20Japanese%20wave%20pattern%20motifs%20fading%20into%20the%20edges%2C%20elegant%20minimalist%20aesthetic%20with%20artistic%20negative%20space%20composition%2C%20no%20text%20or%20characters%2C%20editorial%20quality.&width=1600&height=900&seq=hero-bg-99comic&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50/95 via-background-50/70 to-background-50/30"></div>
      </div>

      <div className="relative w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full max-w-2xl">
            <span className="inline-block px-3 py-1 text-xs font-semibold rounded-full bg-accent-100 text-accent-800 mb-4 whitespace-nowrap">
              全网热门漫画在线阅读平台
            </span>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-4">
              99漫画 — 免费好看的
              <br className="hidden sm:block" />
              韩漫日漫国漫大全
            </h1>
            <p className="text-lg md:text-xl text-primary-500 font-semibold mb-6">
              下拉式流畅阅读 · 实时追更 · 收藏推荐
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8 max-w-lg">
              99漫画网汇聚海量免费韩漫、日漫、国漫资源，提供完整版全集下拉式阅读体验。无论你是追更党还是补番控，这里都有你心水的漫画在线佳作。每日更新、分类清晰、阅读流畅，让每一页漫画都成为享受。
            </p>

            <div className="flex flex-wrap gap-6 mb-8">
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-book-open-line text-primary-500 text-sm"></i>
                </span>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">万部漫画</p>
                  <p className="text-xs text-foreground-500">韩漫·日漫·国漫全覆盖</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-timer-line text-accent-600 text-sm"></i>
                </span>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">每日更新</p>
                  <p className="text-xs text-foreground-500">新鲜内容不停歇</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 rounded-full bg-secondary-100 flex items-center justify-center">
                  <i className="ri-shield-check-line text-secondary-600 text-sm"></i>
                </span>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">完全免费</p>
                  <p className="text-xs text-foreground-500">无需付费畅快阅读</p>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="#carousel"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold rounded-md hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line"></i>
                开始阅读
              </a>
              <a
                href="#app"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-background-50 border border-background-300 text-foreground-800 font-semibold rounded-md hover:bg-background-100 hover:border-primary-300 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-download-line"></i>
                下载APP
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none flex justify-center">
            <div className="relative w-[280px] h-[380px] md:w-[340px] md:h-[460px] overflow-hidden rounded-lg">
              <SafeImg
                src="https://readdy.ai/api/search-image?query=A%20beautiful%20illustration%20of%20a%20digital%20tablet%20displaying%20colorful%20manga%20panels%20with%20Korean%20Japanese%20and%20Chinese%20comic%20art%20styles%20blended%20harmoniously%2C%20warm%20coral%20and%20cream%20background%20with%20soft%20glowing%20accents%2C%20cozy%20reading%20atmosphere%20with%20subtle%20paper%20texture%2C%20modern%20minimalist%20composition%2C%20editorial%20quality%2C%20no%20text%20on%20screen&width=680&height=920&seq=hero-manga-99comic&orientation=portrait"
                alt="99漫画阅读体验"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}